import React from "react";
import { useNavigate } from "react-router";
import AddIcon from "../../assets/icons/addIcon";
import { AdminButton } from "./versionHistoryBtn";

const EditBtn = ({ link = "/" }) => {
  const navigate = useNavigate();
  return (
    <AdminButton
      background="#7065e4"
      color="white"
      width="100px"
      onClick={() => navigate(link)}
    >
      <span className="m-2">EDIT</span>
    </AdminButton>
  );
};

export default EditBtn;
